import React from "react";
import ViewIcon from "../../assets/image/icon_eye.svg";
import Split from "../../assets/image/split.svg";
import {Moments} from "@common/utils/date/moments";
import Delete from "../../assets/image/icon_trash.svg";
import { LazyLoadImage } from 'react-lazy-load-image-component';


function SmallCardVertical({ source = [] || {} }) {

  /*const convertJSONKey = (object, oldKey, newKey) => {
    object[newKey] = object[oldKey];
  }*/

  // Covert Keys
  /*convertJSONKey("source", "oldKey", "newKey")*/

  return (
    <>
      {source.map((eachData) => {
          return (
            <div className="ad-box small-vertical" key={`ad-${eachData.index}`}>
              <LazyLoadImage className="thumbnail-card small-video" src={`${eachData.data.thumbnail.replace("http:", "https:")}`}/>
              <div className="ad-info">
                <h4 className="title">{eachData.data.title} </h4>
                <h5 className="brand">{eachData.data.brand}</h5>
                <div className="row-box">
                  <div className="view-count">
                    <img src={ViewIcon} alt=""/>
                    <span>{eachData.data.rcount}</span>
                  </div>
                  <img src={Split} alt=""/>
                  <div className="created-date">{Moments.Format(eachData.wdate, 'yyyy.MM.DD')}</div>
                </div>
              </div>
            </div>
          )
        }
      )}
    </>
  );
}

export default SmallCardVertical;
